'use client';

import * as layout from '@ocodelib/compose-layout';
import { FlexColumn } from '@ocodelib/mui';
import { useBehaviorSubject } from '@ocodelib/mui/hooks';
import clsx from 'clsx';
import { usePyBasicApp } from '../usePyBasicApp';
import { PLUGIN_KEYS, PLUGIN_KIND_CONTENT } from './plugin-keys';

export function LayoutRoot(props: { className?: string }) {
  const { className } = props;
  const { appManager } = usePyBasicApp();
  const currentTabKey = useBehaviorSubject(appManager.uiState.currentContentTab$);
  const previewMode = useBehaviorSubject(appManager.uiState.previewMode$);

  return (
    <FlexColumn
      alignItems="stretch"
      className={clsx('LayoutRoot-root', className)}
      sx={{
        maxHeight: '100dvh',
        height: '100dvh',
        minWidth: 700,
        bgcolor: '#f1f4f8',
      }}
    >
      <layout.PluginSlot plugin={PLUGIN_KEYS.root.topBar} />
      {/* 프리뷰모드에서는 컨텐트탭을 감춘다 */}
      {!previewMode && <layout.PluginSlot plugin={PLUGIN_KEYS.root.contentTabs} />}

      {currentTabKey && (
        <layout.PluginSelectableSlot
          className="ContentTabView-root"
          pluginKind={PLUGIN_KIND_CONTENT}
          selectedPluginName={currentTabKey ?? ''}
        />
      )}
    </FlexColumn>
  );
}
